(() => {
  const colors = ['#ff2446','#176bff','#25ff75','#ff6a00','#ffe629','#ff34cf'];
  const root = window.POP?.root || '/';

  const formatMoney = (cents) => {
    const amount = (Number(cents || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const format = window.POP?.money || '${{amount}}';
    return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(cents || 0) / 100)));
  };

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));

  const initNeon = (scope = document) => {
    scope.querySelectorAll('[data-neon-title]').forEach(title => {
      if (title.dataset.ready) return;
      let index = 0;
      (title.dataset.words || 'PURPOSE|OVER|PRESSURE').split('|').forEach(word => {
        const line = document.createElement('span');
        line.className = 'neon-line';
        [...word].forEach(char => {
          const letter = document.createElement('span');
          letter.textContent = char;
          letter.style.color = colors[index++ % colors.length];
          line.appendChild(letter);
        });
        title.appendChild(line);
      });
      title.dataset.ready = 'true';
    });
  };

  const drawer = () => document.querySelector('#CartDrawer');
  const overlay = () => document.querySelector('[data-overlay]');
  const openCart = () => { drawer()?.classList.add('open'); overlay()?.classList.add('show'); drawer()?.setAttribute('aria-hidden','false'); document.body.classList.add('locked'); };
  const closePanels = () => { drawer()?.classList.remove('open'); overlay()?.classList.remove('show'); drawer()?.setAttribute('aria-hidden','true'); document.querySelector('[data-mobile-menu]')?.classList.remove('open'); document.body.classList.remove('locked'); };

  const showToast = (message) => {
    let toast = document.querySelector('.toast');
    if (!toast) { toast = document.createElement('div'); toast.className = 'toast'; toast.setAttribute('role','status'); document.body.appendChild(toast); }
    toast.textContent = message; toast.classList.add('show'); window.clearTimeout(showToast.timer); showToast.timer = window.setTimeout(() => toast.classList.remove('show'), 2200);
  };

  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const items = document.querySelector('[data-cart-items]');
    const total = document.querySelector('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
    if (!items) return;
    if (!cart.items.length) { items.innerHTML = '<p class="empty-cart">YOUR CART IS EMPTY.<br>YOUR PURPOSE ISN\'T.</p>'; return; }
    items.innerHTML = cart.items.map((item, index) => `<div class="cart-item"><a href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}&width=160" alt="${escapeHtml(item.product_title)}">` : ''}</a><div><h3>${escapeHtml(item.product_title)}</h3>${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHtml(item.variant_title)}</small><br>` : ''}<button type="button" data-remove-line="${index + 1}">REMOVE</button></div><b>${formatMoney(item.final_line_price)}</b></div>`).join('');
  };

  const getCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart could not load');
    return response.json();
  };

  document.addEventListener('click', async event => {
    if (event.target.closest('[data-cart-open]')) { openCart(); return; }
    if (event.target.closest('[data-cart-close], [data-overlay]')) { closePanels(); return; }
    if (event.target.closest('[data-menu-open]')) { const menu = document.querySelector('[data-mobile-menu]'); menu?.classList.add('open'); menu?.setAttribute('aria-hidden','false'); overlay()?.classList.add('show'); document.body.classList.add('locked'); return; }
    if (event.target.closest('[data-menu-close]') || event.target.closest('[data-mobile-menu] a')) { closePanels(); return; }
    const remove = event.target.closest('[data-remove-line]');
    if (remove) {
      remove.disabled = true;
      try {
        const response = await fetch(`${root}cart/change.js`, { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({ line:Number(remove.dataset.removeLine), quantity:0 }) });
        if (!response.ok) throw new Error('Remove failed');
        renderCart(await response.json());
      } catch (error) { showToast('TRY AGAIN'); remove.disabled = false; }
    }
  });

  document.addEventListener('submit', async event => {
    const form = event.target.closest('.js-quick-add, .js-product-form');
    if (!form || (form.matches('.js-product-form') && !event.submitter?.matches('[data-product-add]'))) return;
    event.preventDefault();
    const button = event.submitter || form.querySelector('button[type="submit"]');
    button.disabled = true;
    try {
      const response = await fetch(`${root}cart/add.js`, { method:'POST', headers:{Accept:'application/json'}, body:new FormData(form) });
      if (!response.ok) throw new Error('Add failed');
      renderCart(await getCart()); openCart();
    } catch (error) { showToast('SELECT AN AVAILABLE OPTION'); }
    finally { button.disabled = false; }
  });

  const initProduct = (scope = document) => {
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      const data = section.querySelector('[data-product-json]');
      if (!data) return;
      let variants; try { variants = JSON.parse(data.textContent); } catch (_) { return; }
      const selects = [...section.querySelectorAll('[data-option-select]')];
      const update = () => {
        const values = selects.map(select => select.value);
        const variant = variants.find(item => item.options.every((value, index) => value === values[index]));
        const id = section.querySelector('[data-variant-id]');
        const price = section.querySelector('[data-product-price]');
        const button = section.querySelector('[data-product-add]');
        if (!variant) { button.disabled = true; button.textContent = 'UNAVAILABLE'; return; }
        id.value = variant.id; price.textContent = formatMoney(variant.price); button.disabled = !variant.available; button.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      };
      selects.forEach(select => select.addEventListener('change', update));
    });
  };

  const initCards = (scope = document) => scope.querySelectorAll('[data-product-card]').forEach(card => {
    card.addEventListener('pointermove', event => {
      if (window.innerWidth < 900 || event.pointerType === 'touch') return;
      const rect = card.getBoundingClientRect(); const x = (event.clientX - rect.left) / rect.width - .5; const y = (event.clientY - rect.top) / rect.height - .5;
      card.style.transform = `perspective(900px) rotateY(${x * 4}deg) rotateX(${-y * 4}deg) translateY(-8px)`;
    });
    card.addEventListener('pointerleave', () => card.style.transform = '');
  });

  const init = (scope = document) => { initNeon(scope); initProduct(scope); initCards(scope); };
  document.addEventListener('DOMContentLoaded', () => { init(); window.setTimeout(() => document.querySelector('[data-intro]')?.classList.add('done'), 1200); });
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
// Prevent double-tap zoom on product cards
document.addEventListener('DOMContentLoaded', function() {
  var lastTap = 0;
  document.querySelectorAll('.product-visual, .product-card a').forEach(function(el) {
    el.addEventListener('touchend', function(e) {
      var now = Date.now();
      if (now - lastTap < 300) {
        e.preventDefault();
        el.click();
      }
      lastTap = now;
    });
  });
});
